import React from "react";

// admin routes
const Dashboard = React.lazy(() =>
  import("../components/Admin/dashboard/Dashboard")
);

const Orders = React.lazy(() => import("../components/Admin/orders/Orders"));

const Settings = React.lazy(() =>
  import("../components/Admin/settings/Settings")
);

const Branches = React.lazy(() =>
  import("../components/Admin/branches/Branches")
);
const Customer = React.lazy(() =>
  import("../components/Admin/customers/Customers")
);

const Stores = React.lazy(() =>
  import("../components/Admin/restaurant/Stores")
);

const Grocery = React.lazy(() => import("../components/Admin/grocery/Stores"));

const Meat = React.lazy(() => import("../components/Admin/meat/Stores"));

const Summary = React.lazy(() => import("../components/Admin/summary/Summary"));

// Branch routes
const BranchDashboard = React.lazy(() =>
  import("../components/Branch/dashboard/branchDashboard")
);

const OrderDetails = React.lazy(() =>
  import("../components/Branch/dashboard/OrderDetails")
);

const BranchStores = React.lazy(() =>
  import("../components/Branch/stores/branchStores")
);

const Products = React.lazy(() =>
  import("../components/Branch/products/Products")
);

const GroceryProducts = React.lazy(() =>
  import("../components/Branch/grocery/products/Products")
);

const MeatProducts = React.lazy(() =>
  import("../components/Branch/meat/products/Products")
);

const Customers = React.lazy(() =>
  import("../components/Branch/customers/Customers")
);

const Delivery = React.lazy(() =>
  import("../components/Branch/delivery/Delivery")
);

const BranchOrders = React.lazy(() =>
  import("../components/Branch/orders/branchOrders")
);

const CompletedOrders = React.lazy(() =>
  import("../components/Branch/orders/completedOrders")
);

const BranchSettings = React.lazy(() =>
  import("../components/Branch/settings/branchSettings")
);

const DailySettle = React.lazy(() =>
  import("../components/Branch/settlement/DailySettle")
);

const StoreSettle = React.lazy(() =>
  import("../components/Branch/settlement/StoreSettle")
);

const BranchGroceryStores = React.lazy(() =>
  import("../components/Branch/grocery/stores/branchStores")
);

const BranchMeatStores = React.lazy(() =>
  import("../components/Branch/meat/stores/branchStores")
);

const Executives = React.lazy(() =>
  import("../components/Branch/executives/Executives")
);

// Delivery Executives Routes
const AssignOrders = React.lazy(() =>
  import("../components/deliveryexecutive/orders/DHEOrders")
);

const DeliveryTodayOrder = React.lazy(() =>
  import("../components/deliveryexecutive/TodaysOrder/DeliveryOrders")
);

// Offline Executives Routes
const CreateOrders = React.lazy(() =>
  import("../components/offlineexe/createOrders/createOrders")
);

const DirectOrder = React.lazy(() =>
  import("../components/offlineexe/directorder/DirectOrder")
);

// Order Executives Routes
const TodaysOrders = React.lazy(() =>
  import("../components/orderexecutive/orders/OHEOrders")
);
const ExecTodaysOrders = React.lazy(() =>
  import("../components/orderexecutive/TodayOrders/ExecTodaysOrders")
);

const adminRoutes = [
  { path: "/dashboard", name: "Dashboard", component: Dashboard },
  { path: "/branches", name: "Branches", component: Branches },
  { path: "/stores", name: "Restaurants", component: Stores },
  { path: "/grocery", name: "Grocery Stores", component: Grocery },
  { path: "/meat", name: "Meat Stores", component: Meat },
  { path: "/orders", name: "Orders", component: Orders },
  { path: "/settings", name: "Settings", component: Settings },
  { path: "/customer", name: "Customer", component: Customer },
  { path: "/summary", name: "Summary", component: Summary },
];

const branchRoutes = [
  { path: "/BranchDashboard", name: "Dashboard", component: BranchDashboard },
  { path: "/orderdetails", name: "Order Details", component: OrderDetails },
  { path: "/BranchStores", name: "Stores", component: BranchStores },
  { path: "/products", name: "Products", component: Products },
  {
    path: "/BranchGroceryStores",
    name: "Stores",
    component: BranchGroceryStores,
  },
  { path: "/grocery-products", name: "Products", component: GroceryProducts },
  {
    path: "/BranchMeatStores",
    name: "Stores",
    component: BranchMeatStores,
  },
  { path: "/meat-products", name: "Products", component: MeatProducts },
  { path: "/delivery", name: "Delivery", component: Delivery },
  { path: "/customers", name: "Customers", component: Customers },
  { path: "/executives", name: "Executives", component: Executives },
  { path: "/BranchOrders", name: "Orders", component: BranchOrders },
  {
    path: "/CompletedOrders",
    name: "Completed Orders",
    component: CompletedOrders,
  },
  {
    path: "/cancelledOrders",
    name: "Cancelled Orders",
    component: CompletedOrders,
  },
  {
    path: "/BranchSettings",
    name: "Branch Settings",
    component: BranchSettings,
  },
  { path: "/dailysettle", name: "Delivery Settlement", component: DailySettle },
  { path: "/restaurantsettle", name: "Accounts", component: StoreSettle },
];

const deliveryRoutes = [
  { path: "/AssignOrders", name: "Todays Orders", component: AssignOrders },
  {
    path: "/todaysOrders",
    name: "Todays Orders",
    component: DeliveryTodayOrder,
  },
];

const offlineRoutes = [
  { path: "/CreateOrders", name: "Create Orders", component: CreateOrders },
  { path: "/todaysOrders", name: "Todays Orders", component: ExecTodaysOrders },
  { path: "/directorder", name: "Direct Order", component: DirectOrder },
];

const orderRoutes = [
  { path: "/currentOrders", name: "Current Orders", component: TodaysOrders },
  { path: "/todaysOrders", name: "Todays Orders", component: ExecTodaysOrders },
];

export {
  adminRoutes,
  branchRoutes,
  deliveryRoutes,
  offlineRoutes,
  orderRoutes,
};
